import { render, staticRenderFns } from "./Confirm.vue?vue&type=template&id=5510ff59&scoped=true"
import script from "./Confirm.vue?vue&type=script&lang=js"
export * from "./Confirm.vue?vue&type=script&lang=js"
import style0 from "./Confirm.vue?vue&type=style&index=0&id=5510ff59&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5510ff59",
  null
  
)

export default component.exports